import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useCustomSearchParams } from 'src/hook';

import langConfig from 'src/config/language';
import Dropdown, { IField } from 'src/components/dropdown';
import { ReactComponent as IconGB } from 'src/assets/icons/flags/gb.svg';

import './dropdown-language.scss';

const flags = {
  en: IconGB,
};

const DropdownLanguage: React.FC = (): JSX.Element | null => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useCustomSearchParams();

  useEffect(() => {
    if (language && Object.keys(langConfig.items).includes(language)) {
      i18n.changeLanguage(language);
    }
  }, []);

  const onSetLanguage = (option: IField) => {
    const { key } = option;

    if (key) {
      language && setLanguage(key);
      i18n.changeLanguage(key);
    }
  };

  const options = Object.keys(langConfig.items).map((lang) => {
    const Icon = flags[lang as keyof typeof flags];
    return {
      value: langConfig.items[lang],
      key: lang,
      icon: Icon && (
        <Icon
          width={15}
          className="icon-flag"
        />
      ),
    };
  });

  if (options.length <= 1) {
    return null;
  }

  return (
    <Dropdown
      wrapperClass="dropdown-language"
      selectedValue={i18n.language}
      onChange={onSetLanguage}
      options={options}
    />
  );
};

export default DropdownLanguage;
